import { render } from "./LinkedTabs.vue?vue&type=template&id=74845972"
import script from "./LinkedTabs.vue?vue&type=script&lang=js"
export * from "./LinkedTabs.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__